import React, { useState } from "react";
import "../style/pages/Faq.css";

const faqs = [
{
  question: "How do I buy skins on SkinForge?",
  answer: "Browse the marketplace, find your favorite skin, and purchase it instantly through our secure checkout — no cart, no delays, just direct buying made simple.",
},
{
  question: "Are the skins on SkinForge authentic?",
  answer: "Yes! Every skin listed on SkinForge is verified for authenticity through trusted checks, ensuring you only get legitimate and original in-game items.",
},
{
  question: "Can I trade my skins here?",
  answer: "Yes, SkinForge lets you trade skins safely and instantly with other players. Our platform ensures fair value and transparent exchanges every time.",
},
{
  question: "How are prices determined?",
  answer: "Skin prices are based on factors like rarity, demand trends, and real-time market activity, keeping every deal fair and competitive for gamers.",
},
{
  question: "Can I preview skins before trading?",
  answer: "Absolutely! You can view each skin in full 360 view with detailed visuals and inspect features before making any trade, ensuring you know exactly what you're getting.",
}
];

function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq">
<h1 className="faq-title">Answers That Clear the Confusion</h1>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              <span>{faq.question}</span>
              <span className="faq-icon">{openIndex === index ? "−" : "+"}</span>
            </div>
            {openIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Faq;
